import { createSelector } from 'reselect';
import { RootState } from 'reducers/rootReducer';

const getActivitiesReducer = (state: RootState) => state.activitiesReducer;

export const fullReducer = createSelector(getActivitiesReducer, (res) => res);
export const currentActivity = createSelector(getActivitiesReducer, (res) => res.currentActivity);
export const pageContext = createSelector(getActivitiesReducer, (res) => res.pageContext);
export const activityStatus = createSelector(getActivitiesReducer, (res) => res.pageContext.filters.activityStatus);
